var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Ticket')]},proxy:true}])},[_c('div',{attrs:{"slot":"sidebar"},slot:"sidebar"},[_c('Sidebar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }